module.exports = __webpack_public_path__ + "img/diesel-locomotive-shadow-01.4deef778.png";